import { Injectable } from '@angular/core';

@Injectable()
export class PermissionsService {

    read(section: string, value: any) {
        if (value === 'public' || value === 'admin') {
            return true;
        }

        var result = false;

        if (section === 'scm' || section === 'build' || section === 'forum'
            || section === 'news' || section === 'frs') {
            result = value >= 0;
        } else {
            result = value >= 1;
        }

        return result;
    }
}
